import { useContext } from 'preact/hooks';
import StoreContext from '../helpers/context';

export default function RecaptchaCheckBox() {
  const {
    state: { recaptcha },
  } = useContext(StoreContext);

  return (
    <div
      className={`g-input-wrapper mb-10 ${
        recaptcha.checkBoxChecked === false ? 'error' : ''
      }
    ${recaptcha.display === true ? '' : 'hide'}`}
    >
      <div id="recaptcha-checkbox"></div>
      <div className="g-input-msg">
        <span>Please verify that you are not a robot</span>
      </div>
    </div>
  );
}
